import MDHeader from 'md-headerjs';
import * as React from 'react';

import { APP_BACKEND_LOGOUT_URL, APP_SIGNUP_URL, DEFAULT_LANG, DEFAULT_THEME } from '@/config';
import { useMe } from '@/hooks/useMe';
import { isAppSumo, isEmBlue } from '@/utils/helpers';

type IconsHeader = {
  alt: string;
  iconClass: string;
};

type ExtraItemsHeader = {
  href?: string;
  name: string;
  iconClass?: string;
  iconImg?: IconsHeader;
  onClick: () => void;
};

export type PrivateHeaderProps = {
  theme?: string;
  authInfo?: any;
  extraItems?: ExtraItemsHeader[];
  lang?: string;
  onChangeCompany?: (companyId: string) => void;
  onChangeLanguage?: (lang: string) => void;
  onLogout?: () => void;
  openSupportChat?: () => void;
  action?: () => void;
  logoutUrl?: string;
  myAccountUrl?: string;
  loadExternalCSS?: boolean;
};

export const PrivateHeader = ({
  theme = DEFAULT_THEME,
  authInfo,
  extraItems,
  lang = DEFAULT_LANG,
  onChangeCompany,
  onChangeLanguage,
  action,
  openSupportChat,
  logoutUrl = APP_BACKEND_LOGOUT_URL,
  onLogout,
  myAccountUrl = APP_SIGNUP_URL + 'accounts',
  loadExternalCSS = false,
  ...props
}: PrivateHeaderProps) => {
  const { getMe } = useMe();
  const me = getMe();

  return (
    <MDHeader
      loadExternalCSS={loadExternalCSS}
      theme={theme}
      lang={lang}
      showCompanies={true}
      onChangeCompany={onChangeCompany}
      onChangeLanguage={onChangeLanguage}
      extraItems={extraItems}
      authInfo={authInfo}
      action={action}
      openSupportChat={openSupportChat}
      logoutUrl={logoutUrl}
      myAccountUrl={myAccountUrl}
      onLogout={onLogout}
      properties={{ isAppSumo: isAppSumo(me), isEmBlue: isEmBlue(me) }}
      bookSessionUrl="https://calendly.com/giulia-landis-embluemail/workshop-tu-nuevo-ecosistema-emblue-ai?utm_source=MDirector-Migración-Help&utm_medium=calendario&utm_campaign=migracion_mdirector&utm_content=help-agendar-cita"
      {...props}
    />
  );
};
